import jStat from 'jstat';
import keys from 'lodash/keys';
import { round6 } from 'utilities/math';
import { GREATER_THAN_VALUE, LESS_THAN_VALUE } from 'scenes/InferentialStatistics/Constants';

const roundAndFormatValue = value => round6(value).toFixed(6);

export const makeStandardError = (sd, n) =>
  sd / Math.sqrt(n);

export const makeTStat = (value, mean, sd, n) =>
  jStat.tscore(value, mean, sd, n);

export const makeOneSidedPValue = (tStat, n) =>
  jStat.ttest(tStat, n, 1);

export const makeTwoSidedPValue = (tStat, n) =>
  jStat.ttest(tStat, n, 2);

export const makeDf = n =>
  (n - 1);

export const makeTConfidenceInterval = (mean, confidenceLevel, standardDeviation, sampleSize) =>
  jStat.tci(+mean, +confidenceLevel, +standardDeviation, +sampleSize);

export const calculateTableDataForOneSampleTHypothesisMean = (hypothesisMean, sampleMean, sampleSize, standardDeviation, altHypothesisSign) => {

  const tableRow = [Number(sampleSize), Number(sampleMean), Number(standardDeviation)];

  tableRow.push(round6(makeStandardError(standardDeviation, sampleSize)));
  tableRow.push(makeDf(sampleSize));

  const tStat = makeTStat(sampleMean, hypothesisMean, standardDeviation, sampleSize);

  tableRow.push(roundAndFormatValue(tStat));

  let pValue = null;

  // p value depends on sign t-statistics and sign of alternative hypothesis
  // jstat calculates p value only with t-statistics > 0 and with GREATER_THAN_VALUE
  // otherwise, we should use the value 1 - p

  switch (altHypothesisSign) {
    case GREATER_THAN_VALUE:
      tStat > 0
        ? pValue = makeOneSidedPValue(tStat, sampleSize)
        : pValue = 1 - makeOneSidedPValue(tStat, sampleSize);
      break;
    case LESS_THAN_VALUE:
      tStat < 0
        ? pValue = makeOneSidedPValue(tStat, sampleSize)
        : pValue = 1 - makeOneSidedPValue(tStat, sampleSize);
      break;

    default: pValue = makeTwoSidedPValue(tStat, sampleSize);
  }
  if (roundAndFormatValue(pValue) === '0.000000') {
    tableRow.push('< 0.00001');
  } else {
    tableRow.push(roundAndFormatValue(pValue));
  }


  // table component might have multiple rows, hence array is nested
  return [tableRow];
};

export const calculateTableDataForOneSampleTConfidenceInterval = (sampleMean, sampleSize, standardDeviation, confidenceLevel) => {

  const tableRow = [Number(sampleSize), Number(sampleMean), Number(standardDeviation)];

  tableRow.push(round6(makeStandardError(standardDeviation, sampleSize)));
  tableRow.push(makeDf(sampleSize));

  const confidenceInterval = makeTConfidenceInterval(sampleMean, (1 - confidenceLevel), standardDeviation, sampleSize);

  // lower limit
  tableRow.push(roundAndFormatValue(confidenceInterval[0]));

  // upper limit
  tableRow.push(roundAndFormatValue(confidenceInterval[1]));

  // table component might have multiple rows, hence array is nested
  return [tableRow];
};

export const getOptionListForDropDown = ({ selectedParametersNames, variableInAnotherDropDown, isFrequencyTable }) => {
  let optionsDataSet = [];
  if (!isFrequencyTable) {
    if (
      selectedParametersNames &&
      selectedParametersNames.length
    ) {
      optionsDataSet = selectedParametersNames.map(key => {
        return {
          value: key,
          text: key
        };
      });
    }
    if (variableInAnotherDropDown) {
      return optionsDataSet.filter(item => item.value !== variableInAnotherDropDown);
    }
  }
  return optionsDataSet;
};

export const getLevelsOptionsForChosenVariable = (categoricalOption, categoricalSummary) => {
  let optionsDataSet = [];
  if (
    categoricalOption &&
    categoricalSummary[categoricalOption] &&
    categoricalSummary[categoricalOption].levels
  ) {
    const categoricalLevels = categoricalSummary[categoricalOption].levels;

    optionsDataSet = keys(categoricalLevels).map(level => ({
      value: level,
      label: level,
      text: level
    }));
  }
  return optionsDataSet;
};
